module.exports = __webpack_public_path__ + "static/logo-github2-5e89d88c15b7b9997f094954c3e52dd1.png";